import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Breadcrumb } from "antd";
import { Link, useParams } from "react-router-dom";

import { __ } from "../../locales/translation";
import { ComponentContainer, LayoutGrid } from "../LayoutContainers";
import { fetchMarketStatus } from "../../utils/fetchers";
import ProductValueAndVar from "../ProductValueAndVar";
import BadgeTag from "../BadgeTags";
import Pill from "../Pill";
import TabsControls from "../TabsControls";

export default function HeroProductMaxCapital({ data }) {
    const {
        clase,
        siblings,
        id,
        descripcion,
        sociedadGerente,
        variacion,
        esDestacado,
        precioUltimo,
        moneda,
        objetivo,
        logo,
        fecha,
    } = data;

    const params = useParams();

    const [activeTab, setActiveTab] = useState(() => (clase.includes("Clase A") ? "tabId1" : "tabId2"));

    const tabsOptionsTags = ["CLASE A", "CLASE B"];

    const { data: marketStatusData, isLoading: isLoadingMarketStatus } = useQuery({
        queryKey: ["marketStatus"],
        queryFn: fetchMarketStatus,
        refetchOnReconnect: true,
    });

    const tabsOptions = tabsOptionsTags.map((tag, i) => {
        return {
            id: `tabId${i + 1}`,
            label: tag,
            fondoId: clase.toLowerCase() === tag.toLocaleLowerCase() ? id : siblings[0] || false,
        };
    });

    return (
        <ComponentContainer image={`${window._env_.STATIC_HOST}/static/website/images/hero-cot-product.jpg`}>
            <LayoutGrid spacingTop="0" spacingBottom="0" cols={1}>
                <div className="cot-hero-product-detail">
                    <Breadcrumb
                        items={[
                            {
                                title: (
                                    <Link data-external-check-exempt to="/">
                                        {__("Cotizaciones")}
                                    </Link>
                                ),
                            },
                            {
                                title: (
                                    <Link data-external-check-exempt to={`/${params.productType}`}>
                                        {params.productType}
                                    </Link>
                                ),
                            },
                            {
                                title: `${descripcion} - ${sociedadGerente}`,
                            },
                        ]}
                    />

                    <TabsControls controlOptions={tabsOptions} activeTab={activeTab} setActiveTab={setActiveTab} />

                    <div className="content-wrapper">
                        <div className="cot-product-name">
                            {logo && <img className="ticker-logo" src={logo} alt={descripcion} />}

                            <div className="data-wrapper">
                                {descripcion && <h1 className="title-2">{descripcion}</h1>}
                                {sociedadGerente && <h4 className="title-5">{sociedadGerente}</h4>}
                                {esDestacado ? <Pill type="highlighted" text={__("Destacado")} /> : null}
                            </div>
                        </div>

                        <div className="product-info-values-wrapper">
                            <ProductValueAndVar
                                variacion={variacion.diaria}
                                variationLabel={__("Variación diaria")}
                                precioUltimo={precioUltimo}
                                moneda={moneda}
                                clase={clase}
                            />
                        </div>
                    </div>

                    <div className="cot-hero-footer">
                        {objetivo && <p className="paragraph">{objetivo}</p>}

                        <div className="indicators">
                            <div className="refresh-content">
                                <span className="small-text">
                                    {__("Fuente")} CAFCI
                                </span>

                                {/* dot */}
                                <svg
                                    width="2"
                                    height="2"
                                    viewBox="0 0 2 2"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle cx="1" cy="1" r="1" fill="currentColor" fillOpacity="0.7" />
                                </svg>

                                <span className="small-text">{__("Actualización")}</span>

                                {/* dot */}
                                <svg
                                    width="2"
                                    height="2"
                                    viewBox="0 0 2 2"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle cx="1" cy="1" r="1" fill="currentColor" fillOpacity="0.7" />
                                </svg>

                                <span className="small-text">{fecha}</span>

                                {/* <span className="small-text">{999}</span>

                                <span className="small-text">-</span>

                                <span className="small-text">{999}</span> */}
                            </div>

                            <div className="badge-container">
                                {!isLoadingMarketStatus && (
                                    <BadgeTag
                                        type={marketStatusData?.abierto ? "open-market" : "close-market"}
                                        marketTag
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutGrid>
        </ComponentContainer>
    );
}
